<control-wrapper [control]="control" name="password" [label]="label" [validationErrors]="validationMessages.password">
  <input id="password" formControlName="password" type="password" class="form-control" (input)="updateErrorMessages()">
</control-wrapper>
